/**
 * =========================================================
 * Social Media Hub - Premium Sidenav Styles
 * =========================================================
 *
 * Modern, sleek sidebar with glass morphism effects,
 * smooth transitions, and premium visual aesthetics.
 */

// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 280;
  const { transparent, gradients, white, background, grey } = palette;
  const { xxl, lg } = boxShadows;
  const { pxToRem, linearGradient } = functions;

  // Premium gradient background for dark mode or default
  let backgroundValue = darkMode
    ? linearGradient(gradients.dark.main, gradients.dark.state)
    : white.main;

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav
        ? "none"
        : "0 0 60px rgba(0, 0, 0, 0.06), 0 0 20px rgba(0, 0, 0, 0.04)",
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color", "box-shadow"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : "0 0 30px rgba(0, 0, 0, 0.04)",
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: pxToRem(88),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color", "box-shadow"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: "0 0 60px rgba(0, 0, 0, 0.06), 0 0 20px rgba(0, 0, 0, 0.04)",
      border: "none",
      borderRadius: 0,
      marginTop: 0,
      height: "100vh",
      position: "fixed",
      left: 0,
      top: 0,

      // Premium scrollbar
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        background: grey[300],
        borderRadius: "4px",
        "&:hover": {
          background: grey[400],
        },
      },

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
